import TextLoop from "./components/TextLoop";
export default TextLoop;